import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./ProjectCarousel.scss";
import {
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
  Box
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import GitHubIcon from "@mui/icons-material/GitHub";

export interface Project {
  title: string;
  description: string;
  image: string;
  live?: string;
  code?: string;
  tags?: string[];
}

export interface ProjectCarouselProps {
  projects?: Project[];
  onViewAll?: () => void;
}

const ProjectCarousel: React.FC<ProjectCarouselProps> = ({
  projects = [],
  onViewAll
}) => {
  const isSingle = (projects?.length || 0) === 1;

  if (!projects.length) {
    return null;
  }

  return (
    <div className="project-carousel">
      <Swiper
        modules={[Navigation]}
        centeredSlides
        loop={projects.length > 1}
        speed={500}
        navigation={{
          nextEl: ".project-carousel__next",
          prevEl: ".project-carousel__prev"
        }}
        breakpoints={{
          0: { slidesPerView: 1.2, spaceBetween: 12 },
          640: { slidesPerView: 3, spaceBetween: 16 },
          1024: { slidesPerView: 5, spaceBetween: 20 }
        }}
        className="project-carousel__swiper"
      >
        {projects.map((p, idx) => (
          <SwiperSlide
            key={idx}
            className={`project-slide ${isSingle ? "no-dim" : ""}`}
          >
            <Card className="project-card" elevation={4}>
              <Box className="project-card__img">
                <CardMedia
                  component="img"
                  image={p.image}
                  alt={p.title}
                  loading="lazy"
                />
                <Box className="project-card__overlay">
                  {p.live && (
                    <IconButton
                      component="a"
                      href={p.live}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${p.title} live demo`}
                      size="small"
                    >
                      <OpenInNewIcon fontSize="small" />
                    </IconButton>
                  )}
                  {p.code && (
                    <IconButton
                      component="a"
                      href={p.code}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`${p.title} source code`}
                      size="small"
                    >
                      <GitHubIcon fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              </Box>

              <CardContent className="project-card__content">
                <Typography variant="subtitle1" component="h4">
                  {p.title}
                </Typography>
                <Typography
                  variant="body2"
                  className="project-card__desc"
                  color="text.secondary"
                >
                  {p.description}
                </Typography>
              </CardContent>
            </Card>
          </SwiperSlide>
        ))}
      </Swiper>

      {projects.length > 1 && (
        <>
          <button className="project-carousel__prev" aria-label="Previous">
            ‹
          </button>
          <button className="project-carousel__next" aria-label="Next">
            ›
          </button>
        </>
      )}

      {/* {onViewAll && projects.length > 3 && (
        <button
          type="button"
          className="project-carousel__view-all"
          onClick={onViewAll}
        >
          View all projects
        </button>
      )} */}
    </div>
  );
};

export default ProjectCarousel;


